// frontend/src/presentation/speech/voskModel.ts
//
// Wspólny adres modelu STT offline. Serwowany z tego samego origin
// (`public/models/`, patrz `scripts/fetch-vosk-model.mjs` + `.gitignore`),
// cache'owany runtime przez Service Workera (`vite.config.ts` → `vosk-stt-model`).

export const VOSK_MODEL_URL = '/models/vosk-model-small-pl-0.22.tar.gz'
